window.DS24 = window.DS24 || {};

DS24.gift = (() => {

    let giftProcessing = false;

    let progressPercent = 0;

    /*
    |--------------------------------------------------------------------------
    | HELPERS
    |--------------------------------------------------------------------------
    */

    function unlockProcessing() {

        setTimeout(() => {
            giftProcessing = false;
        }, 1000);
    }

    /*
    |--------------------------------------------------------------------------
    | REMOVE GIFT
    |--------------------------------------------------------------------------
    */

    function removeGift() {

        const cart = getActiveCartContainer();

        if (!cart) {
            return;
        }

        const removeBtn = cart.querySelector(
            `.app_cart_delete[app-product-id="${DS24_CONFIG.freeGiftId}"]`
        );

        if (!removeBtn) {
            return;
        }

        removeBtn.click();
    }


    /*
    |--------------------------------------------------------------------------
    | CART LIST
    |--------------------------------------------------------------------------
    */

    function getCartList() {

        const cart = getActiveCartContainer();

        if (!cart) {
            return null;
        }

        return cart.querySelector(
            '.app_cart_list'
        );
    }

    /*
    |--------------------------------------------------------------------------
    | PROGRESS BAR
    |--------------------------------------------------------------------------
    */

    function getActiveCartContainer() {

        const carts = [
            ...document.querySelectorAll(
                '.app_cart_tooltip_container.open'
            )
        ];

        if (!carts.length) {
            return null;
        }

        /*
        |--------------------------------------------------------------------------
        | RETURN LAST OPEN CART
        |--------------------------------------------------------------------------
        */

        return carts[carts.length - 1];
    }

    function getProgressBar() {

        const cart = getActiveCartContainer();

        if (!cart) {
            return null;
        }

        return cart.querySelector(
            '.free-gift-progress'
        );
    }

    function createProgressBar() {

        /*
        |--------------------------------------------------------------------------
        | ALREADY EXISTS
        |--------------------------------------------------------------------------
        */

        const existing = getProgressBar();

        if (existing) {
            return existing;
        }

        /*
        |--------------------------------------------------------------------------
        | TARGET
        |--------------------------------------------------------------------------
        */

        const cart = getActiveCartContainer();

        if (!cart) {
            return null;
        }

        const target = cart.querySelector(
            '.app_cart_list'
        );

        if (!target) {
            return null;
        }

        /*
        |--------------------------------------------------------------------------
        | CREATE ONCE
        |--------------------------------------------------------------------------
        */

        target.insertAdjacentHTML(
            'beforebegin',
            `
                <div class="free-gift-progress">

                    <div class="free-gift-progress__top">

                        <div class="free-gift-progress__icon">
                            🎁
                        </div>

                        <div class="free-gift-progress__content">

                            <div class="free-gift-progress__text"></div>

                            <div class="free-gift-progress__bar">

                                <div
                                    class="free-gift-progress__fill"
                                ></div>

                            </div>

                        </div>

                    </div>

                </div>
            `
        );

        return getProgressBar();
    }

    /*
    |--------------------------------------------------------------------------
    | RENDER PROGRESS BAR
    |--------------------------------------------------------------------------
    */

    function renderProgressBar(subtotal) {

        const remaining = Math.max(
            0,
            DS24_CONFIG.freeGiftThreshold - subtotal
        );

        const percent = Math.min(
            100,
            (subtotal / DS24_CONFIG.freeGiftThreshold) * 100
        );

        let progress = getProgressBar();

        if (!progress) {
            progress = createProgressBar();
        }

        if (!progress) {
            return;
        }

        const text = progress.querySelector(
            '.free-gift-progress__text'
        );

        const fill = progress.querySelector(
            '.free-gift-progress__fill'
        );

        /*
        |--------------------------------------------------------------------------
        | UPDATE TEXT
        |--------------------------------------------------------------------------
        */

        text.innerHTML = remaining > 0
            ? `
                Noch
                <strong>
                    ${remaining.toFixed(2)} EUR
                </strong>
                und du erhältst ein kostenfreies Produkt
            `
            : `
                🎉 Ihr kostenloses Geschenk ist freigeschaltet.
            `;

        /*
        |--------------------------------------------------------------------------
        | UNLOCKED STATE
        |--------------------------------------------------------------------------
        */

        progress.classList.toggle(
            'unlocked',
            remaining <= 0
        );

        /*
        |--------------------------------------------------------------------------
        | ANIMATE WIDTH
        |--------------------------------------------------------------------------
        */

        fill.style.width = `${progressPercent}%`;

        requestAnimationFrame(() => {

            requestAnimationFrame(() => {

                fill.style.width = `${percent}%`;

                progressPercent = percent;
            });
        });
    }

    /*
    |--------------------------------------------------------------------------
    | SUBTOTAL
    |--------------------------------------------------------------------------
    */

    function subtotal(cart) {

        return cart.items.reduce((total, item) => {

            if (
                Number(item.product_id) === Number(DS24_CONFIG.freeGiftId) ||
                Number(item.quantity || 0) <= 0
            ) {
                return total;
            }

            return total + (
                Number(item.gross_amount || 0) *
                Number(item.quantity || 0)
            );

        }, 0);
    }

    /*
    |--------------------------------------------------------------------------
    | HAS GIFT
    |--------------------------------------------------------------------------
    */

    function hasGift(cart) {

        return cart.items.some(item =>
            Number(item.product_id) === Number(DS24_CONFIG.freeGiftId) &&
            Number(item.quantity || 0) > 0
        );
    }

    /*
    |--------------------------------------------------------------------------
    | HANDLE
    |--------------------------------------------------------------------------
    */

    function handle(cart) {

        const cartSubtotal = subtotal(cart);

        const giftExists = hasGift(cart);

        /*
        |--------------------------------------------------------------------------
        | RENDER
        |--------------------------------------------------------------------------
        */

        setTimeout(() => {

            renderProgressBar(
                cartSubtotal
            );

        }, 300);

        /*
        |--------------------------------------------------------------------------
        | PREVENT DUPLICATES
        |--------------------------------------------------------------------------
        */

        if (giftProcessing) {
            return;
        }

        /*
        |--------------------------------------------------------------------------
        | ADD GIFT
        |--------------------------------------------------------------------------
        */

        if (
            cartSubtotal >= DS24_CONFIG.freeGiftThreshold &&
            !giftExists
        ) {

            giftProcessing = true;

            ds24cart_add(
                DS24_CONFIG.freeGiftId,
                1
            );

            unlockProcessing();

            return;
        }

        /*
        |--------------------------------------------------------------------------
        | REMOVE GIFT
        |--------------------------------------------------------------------------
        */

        if (
            cartSubtotal < DS24_CONFIG.freeGiftThreshold &&
            giftExists
        ) {

            giftProcessing = true;

            removeGift();

            unlockProcessing();
        }
    }

    return {
        handle,
    };

})();